import ModalWrapper from './Modal';
export default ModalWrapper;
